import axiosRetry from 'axios-retry';
const ACCEPTED_ERROR_STATUS_CODES = [
    400, 401, 403, 404, 405,
    406, 409, 410, 411, 412,
    413, 414, 415, 416, 417,
    418, 420, 422, 423, 424,
    425, 426, 428, 431, 444,
    449, 450, 451
];
export const standardRetryPolicy = {
    retries: 3,
    retryCondition: err => axiosRetry.isNetworkOrIdempotentRequestError(err) || (err && err.response && !ACCEPTED_ERROR_STATUS_CODES.includes(err.response.status)) || false
};
//# sourceMappingURL=axiosRetryPolicy.js.map